export default {
    name: "ExportData",
    title: "ExportData",
    icon: "mdi-database-export",
    create() {
        return {
            name: this.name,
            description: null,
            actionType: this.name,
            table: null,
            filters: [],
            columns: [],
        };
    },
};